export default __webpack_public_path__ + "italicize-text.png";